import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { AgencyEditorData } from "../../state/Agencies/EditorData";


const updateAgencyEditorData: Reducer<AgencyEditorData> = (state: AgencyEditorData = new AgencyEditorData(), action: Action<ActionType, AgencyEditorData>) => {
  switch (action.type) {
    case ActionType.AGENCIES_EDITOR_DATA_RESET:
      return new AgencyEditorData();
    case ActionType.AGENCIES_EDITOR_DATA_FETCHED:
      return { ...state, agencyData: action.data };
    case ActionType.AGENCIES_EDITOR_DATA_COPIED:
      return { ...state, agencyData: { ...action.data} };
    case ActionType.AGENCIES_EDITOR_DATA_UPDATED:
      return { ...state, agencyData: { ...state.agencyData, ...action.data } };
    case ActionType.AGENCIES_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.AGENCIES_EDITOR_DATA_VALIDATED:
      return { ...state, validation: action.data };
    case ActionType.AGENCIES_EDITOR_DATA_SET_BRAND_AND_MARKET:
      return { ...state, agencyData: {brandAndMarket: action.data} };
    default:
      return state;
  }
};

export default updateAgencyEditorData;
